export default "__VITE_ASSET__D0bcu0ZM__"